import styled from 'styled-components';

export default styled.h3`
  font-family: 'Maison Neue';
  font-size: 20px;
  color: #201e1e;
  font-weight: 700;
  margin: 0;
  margin-bottom: 10px;
  &.title_customer-name {
    display: flex;
    align-items: center;
  }
  .tag {
    margin-left: 5px;
    font-size: 14px;
    font-weight: 550;
    padding: 4px 10px 3px;
    border-radius: 15px;
    &.partner {
      background-color: #919495;
      color: white;
    }
    &.promo {
      background-color: #2b9bff;
      color: white;
      white-space: nowrap;
    }
  }
`;
